import { Grid, Skeleton } from '@mui/material';
import { useDealRequestAllocationRealEstatesQuery } from '../../shared/hooks';
import { DealRequestAllocation, DealRequestAllocationRealEstate } from '../../shared/models';
import { NumberUtils } from '../../shared/utils';
import { ReactComponent as OwnerOccupiedRealEstate } from '../../shared/icons/OwnerOccupiedRealEstate.svg';
import { DebtCapitalHeading } from './DebtCapitalHeading';
import {
	CerebroComplexListItem,
	CerebroHeading,
	CerebroLabel,
	CerebroStyledBox,
	CerebroText,
} from '../../shared/components';
import NumberFormat from 'react-number-format';

interface DebtRealEstateProps {
	allocation: DealRequestAllocation;
}

export const DebtRealEstate: React.FC<DebtRealEstateProps> = ({ allocation }) => {
	const realEstateQuery = useDealRequestAllocationRealEstatesQuery(allocation.dealGuid);
	if (realEstateQuery.isLoading) {
		return <Skeleton height={400} />;
	}

	const totalCount = realEstateQuery.data?.length ?? 0;

	const amountRequested = NumberUtils.Sum(
		...(realEstateQuery.data?.map(
			realEstate => (realEstate?.termLoanNeeds ?? 0) + (realEstate?.revolvingDebtNeeds ?? 0)
		) ?? [])
	);

	return (
		<>
			<DebtCapitalHeading icon={OwnerOccupiedRealEstate} amountRequested={amountRequested}>
				Owner-Occupied Real Estate
			</DebtCapitalHeading>

			{totalCount === 0 ? (
				<>
					<CerebroStyledBox sx={{ marginBottom: 8 }}>
						<CerebroHeading size="h2" component="h2">
							No details have been added yet.
						</CerebroHeading>
						<br />
					</CerebroStyledBox>
				</>
			) : (
				<></>
			)}

			{totalCount > 0 ? (
				<>
					{realEstateQuery.data?.map((item: DealRequestAllocationRealEstate) => (
						<CerebroComplexListItem key={item.guid} sx={{ marginTop: 2 }}>
							<Grid container>
								<Grid item xs={4}>
									<CerebroLabel>Category</CerebroLabel>
									<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
										{item.realEstateType}
									</CerebroText>
								</Grid>
								<Grid item xs={4}>
									<CerebroLabel>Requested Amount</CerebroLabel>
									<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
										<NumberFormat
											value={(item.termLoanNeeds ?? 0) + (item.revolvingDebtNeeds ?? 0)}
											displayType="text"
											thousandSeparator={true}
											prefix="$"
										/>
									</CerebroText>
								</Grid>
								<Grid item xs={4}>
									<CerebroLabel>Equity</CerebroLabel>
									<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
										<NumberFormat
											value={item.cashEquity}
											displayType="text"
											thousandSeparator={true}
											prefix="$"
										/>
									</CerebroText>
								</Grid>
							</Grid>
						</CerebroComplexListItem>
					))}
				</>
			) : (
				<></>
			)}
		</>
	);
};
